module.exports = __webpack_public_path__ + "media/images/markers/dropoff-2x-1fcbae7ffb51ef2ff27af19fcc623641.png";